import { Color } from '../../../app/StyleGuide';

export const SCORE_COLORS = {
  consistent: '#4db6ac',
  moderate: Color.Orange._50,
  limited: Color.Red._50,
} as const;

export type ScoreLevel = keyof typeof SCORE_COLORS;

export const getScoreLevel = (score: number): ScoreLevel => {
  if (score >= 4) return 'consistent';
  if (score >= 2) return 'moderate';
  return 'limited';
};

export const SCORE_LEVEL_LABELS: Record<ScoreLevel, string> = {
  consistent: 'Consistent Evidence of Spiritual Growth',
  moderate: 'Moderate Evidence of Spiritual Growth',
  limited: 'Limited Evidence of Spiritual Growth',
};

export const scoreToProgressPercent = (score: number, maxScore = 5) => (score / maxScore) * 100;

export const GAUGE_SEGMENT_COUNT = 5;

/** Score level for a 1-based gauge segment (each segment spans one point on the 0–5 scale). */
export const getScoreLevelForGaugeSegment = (segment: number): ScoreLevel => getScoreLevel(segment - 0.5);
